import { useQuery } from "@tanstack/react-query";
import { GetStockHistory } from "../Api";
import { ServiceQueryOptions, unwrapApiResponse } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const stockHistoryQueryKeys = {
  stockHistory: (params?: Parameters<typeof GetStockHistory>[0]) =>
    ["stockHistory", params] as const,
};

export const useStockHistoryQuery = (
  params: Parameters<typeof GetStockHistory>[0],
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: stockHistoryQueryKeys.stockHistory(params),
    queryFn: async () => unwrapApiResponse(await GetStockHistory(params)),
  });
};
